/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeCompanyStatuses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Status Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:18 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const COMPANYSTATUS_LIST_CONTAINER_LOADED = 'COMPANYSTATUS_LIST_CONTAINER_LOADED';
export const COMPANYSTATUS_LIST_CONTAINER_UNLOADED = 'COMPANYSTATUS_LIST_CONTAINER_UNLOADED';
export const COMPANYSTATUS_LIST_TABLE_LOADED = 'COMPANYSTATUS_LIST_TABLE_LOADED';
export const COMPANYSTATUS_LIST_TABLE_UNLOADED = 'COMPANYSTATUS_LIST_TABLE_UNLOADED';
export const COMPANYSTATUS_SELECT_ROW = 'COMPANYSTATUS_SELECT_ROW';
export const COMPANYSTATUS_ADD = 'COMPANYSTATUS_ADD';
export const COMPANYSTATUS_EDIT = 'COMPANYSTATUS_EDIT';
export const COMPANYSTATUS_DELETE = 'COMPANYSTATUS_DELETE';
export const COMPANYSTATUS_OPEN_WARNING = 'COMPANYSTATUS_OPEN_WARNING';
export const COMPANYSTATUS_CLOSE_WARNING = 'COMPANYSTATUS_CLOSE_WARNING';

export const COMPANYSTATUS_EDIT_CONTAINER_LOADED = 'COMPANYSTATUS_EDIT_CONTAINER_LOADED';
export const COMPANYSTATUS_EDIT_CONTAINER_UNLOADED = 'COMPANYSTATUS_EDIT_CONTAINER_UNLOADED';
export const COMPANYSTATUS_EDIT_FORM_LOADED = 'COMPANYSTATUS_EDIT_FORM_LOADED';
export const COMPANYSTATUS_EDIT_FORM_UNLOADED = 'COMPANYSTATUS_EDIT_FORM_UNLOADED';
export const COMPANYSTATUS_EDIT_DATA_LOAD = 'COMPANYSTATUS_EDIT_DATA_LOAD';
export const COMPANYSTATUS_EDIT_CONTAINER_SUBMIT = 'COMPANYSTATUS_EDIT_CONTAINER_SUBMIT';
export const COMPANYSTATUS_EDIT_CONTAINER_CANCEL = 'COMPANYSTATUS_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeCompanyStatuses.js